
// ===================================================
// JURÍDICO & COMPLIANCE
// ===================================================
const JUR_CATEGORIAS={
  judicial:'Processo judicial',trabalhista:'Processo trabalhista',administrativo:'Processo administrativo',
  notificacao:'Notificação / intimação',contrato:'Contrato',licenca:'Licença / alvará',certidao:'Certidão',
  seguro:'Seguro',procuracao:'Procuração',obrigacao:'Obrigação regulatória',societario:'Societário',
  tributario:'Tributário',consumidor:'Consumidor / PROCON',ambiental:'Ambiental',
  seguranca_trabalho:'Segurança do trabalho',lgpd:'Proteção de dados (LGPD)',
  auditoria:'Auditoria',politica_interna:'Política interna',compliance:'Compliance',
  fiscal:'Fiscal / regulatório',outro:'Outro'
};
// Grupos de categoria para inferir status e ícone
const JUR_GRUPO={
  processo:['judicial','trabalhista','administrativo','consumidor','tributario','ambiental'],
  contrato:['contrato','procuracao'],
  licenca:['licenca','certidao','seguro','seguranca_trabalho'],
  obrigacao:['obrigacao','compliance','fiscal','lgpd','societario','politica_interna','auditoria'],
  notificacao:['notificacao'],
};
const JUR_STATUS_POR_GRUPO={
  processo:{
    em_analise:'Em análise',ativo:'Ativo',aguardando_manifestacao:'Aguardando manifestação',
    aguardando_audiencia:'Aguardando audiência',aguardando_decisao:'Aguardando decisão',
    em_recurso:'Em recurso',em_acordo:'Em acordo',suspenso:'Suspenso',
    encerrado_favoravel:'Encerrado favorável',encerrado_desfavoravel:'Encerrado desfavorável',arquivado:'Arquivado'
  },
  contrato:{
    rascunho:'Rascunho',em_revisao:'Em revisão',aguardando_aprovacao:'Aguardando aprovação',
    aguardando_assinatura:'Aguardando assinatura',vigente:'Vigente',proximo_vencimento:'Próximo do vencimento',
    renovacao_andamento:'Renovação em andamento',rescindido:'Rescindido',encerrado:'Encerrado',cancelado:'Cancelado'
  },
  licenca:{
    em_cadastramento:'Em cadastramento',valido:'Válido',proximo_vencimento:'Próximo do vencimento',
    renovacao_iniciada:'Renovação iniciada',renovacao_pendente:'Renovação pendente',
    vencido:'Vencido',suspenso:'Suspenso',cancelado:'Cancelado',nao_aplicavel:'Não aplicável'
  },
  obrigacao:{
    conforme:'Conforme',atencao:'Atenção',nao_conforme:'Não conforme',em_tratamento:'Em tratamento',
    aguardando_evidencia:'Aguardando evidência',suspenso:'Suspenso',critico:'Crítico',arquivado:'Arquivado'
  },
  notificacao:{
    recebida:'Recebida',em_analise:'Em análise',em_resposta:'Em resposta',respondida:'Respondida',
    prazo_vencido:'Prazo vencido',arquivada:'Arquivada'
  },
};
// Status legados e genéricos (compatibilidade retroativa)
const JUR_STATUS={
  aberto:'Aberto',em_andamento:'Em andamento',aguardando:'Aguardando',cumprido:'Cumprido',encerrado:'Encerrado',
  em_analise:'Em análise',ativo:'Ativo',aguardando_manifestacao:'Aguardando manifestação',
  aguardando_audiencia:'Aguardando audiência',aguardando_decisao:'Aguardando decisão',
  em_recurso:'Em recurso',em_acordo:'Em acordo',suspenso:'Suspenso',
  encerrado_favoravel:'Encerrado favorável',encerrado_desfavoravel:'Encerrado desfavorável',arquivado:'Arquivado',
  rascunho:'Rascunho',em_revisao:'Em revisão',aguardando_aprovacao:'Aguardando aprovação',
  aguardando_assinatura:'Aguardando assinatura',vigente:'Vigente',proximo_vencimento:'Próximo do vencimento',
  renovacao_andamento:'Renovação em andamento',rescindido:'Rescindido',cancelado:'Cancelado',
  em_cadastramento:'Em cadastramento',valido:'Válido',renovacao_iniciada:'Renovação iniciada',
  renovacao_pendente:'Renovação pendente',vencido:'Vencido',nao_aplicavel:'Não aplicável',
  conforme:'Conforme',atencao:'Atenção',nao_conforme:'Não conforme',em_tratamento:'Em tratamento',
  aguardando_evidencia:'Aguardando evidência',critico:'Crítico',
  recebida:'Recebida',em_resposta:'Em resposta',respondida:'Respondida',prazo_vencido:'Prazo vencido',arquivada:'Arquivada'
};
const JUR_RISCOS={baixo:'Baixo',moderado:'Moderado',alto:'Alto',critico:'Crítico'};
const JUR_PROBABILIDADE={nao_avaliada:'Não avaliada',remota:'Remota',possivel:'Possível',provavel:'Provável',confirmada:'Confirmada',encerrada:'Encerrada'};
const JUR_CONFIDENCIALIDADE={interno:'Interno',restrito:'Restrito',juridico:'Restrito · Jurídico',diretoria:'Restrito · Diretoria',sigiloso:'Sigiloso'};
function jurGrupoDaCategoria(cat=''){return Object.entries(JUR_GRUPO).find(([,cats])=>cats.includes(cat))?.[0]||'processo'}
function jurStatusOptions(cat){const g=jurGrupoDaCategoria(cat);return JUR_STATUS_POR_GRUPO[g]||JUR_STATUS_POR_GRUPO.processo}
function jurStatusIsFinal(status){return['encerrado','encerrado_favoravel','encerrado_desfavoravel','arquivado','arquivada','cancelado','rescindido','cumprido'].includes(status)}
// Cores de risco para borda e badge
function jurRiscoCor(risco){return risco==='critico'?'var(--red)':risco==='alto'?'#f06595':risco==='moderado'?'var(--warn)':'var(--green)'}
function jurRiscoBadge(risco){return risco==='critico'?'urgente':risco==='alto'?'alta':risco==='moderado'?'normal':'normal'}

function formatCNPJ(valor){
  const d=String(valor||'').replace(/\D/g,'').slice(0,14);if(!d)return '';
  return d.replace(/^(\d{2})(\d)/,'$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/,'$1.$2.$3').replace(/\.(\d{3})(\d)/,'.$1/$2').replace(/(\d{4})(\d)/,'$1-$2');
}
function validarCNPJ(valor){
  const n=String(valor||'').replace(/\D/g,'');if(n.length!==14||/^(\d)\1+$/.test(n))return false;
  const calc=tamanho=>{let soma=0,pos=tamanho-7;for(let i=tamanho;i>=1;i--){soma+=Number(n[tamanho-i])*pos--;if(pos<2)pos=9}const r=soma%11;return r<2?0:11-r};
  return calc(12)===Number(n[12])&&calc(13)===Number(n[13]);
}
function usarCNPJEmpresaNoJuridico(){
  const cnpj=formatCNPJ((CACHE.config||{}).cnpj||'');const el=document.getElementById('jur-cnpj');if(el)el.value=cnpj;
  if(!cnpj)toast('Cadastre primeiro o CNPJ em Configurações.','error');
}

function jurPrazoInfo(j){
  // Use o prazo mais próximo não cumprido entre prazos[] ou campo legado prazo
  const isFinal=jurStatusIsFinal(j.status);
  const prazosArr=(j.prazos||[]).filter(p=>p.data&&p.status!=='cumprido');
  const prazoLegado=j.prazo&&!isFinal?j.prazo:null;
  const allDatas=[...prazosArr.map(p=>p.data),prazoLegado].filter(Boolean).sort();
  const proximaData=allDatas[0]||null;
  if(!proximaData||isFinal)return{classe:'',texto:proximaData?fmtD(proximaData):'Sem prazo'};
  const dias=Math.round((new Date(proximaData+'T12:00:00')-new Date(today()+'T12:00:00'))/86400000);
  if(dias<0)return{classe:'red',texto:`Vencido há ${Math.abs(dias)} dia${Math.abs(dias)!==1?'s':''}`};
  if(dias===0)return{classe:'red',texto:'Vence hoje'};
  if(dias<=3)return{classe:'red',texto:`Vence em ${dias} dia${dias!==1?'s':''}`};
  if(dias<=7)return{classe:'warn',texto:`Vence em ${dias} dia${dias!==1?'s':''}`};
  if(dias<=30)return{classe:'warn',texto:`${dias}d · ${fmtD(proximaData)}`};
  return{classe:'green',texto:fmtD(proximaData)};
}

